import Vue from 'vue';
import Router from 'vue-router';
import MainView from './views/main';
import RouteNotFound from './views/route-not-found';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/:arkona/:oppId/:type?',
            name: 'MainView',
            component: MainView,
        },
        {
            // catch unknown paths
            path: '*',
            name: 'RouteNotFound',
            component: RouteNotFound,
        },
    ],
});
